export default __webpack_public_path__ + "media/images/brands/demo/other/services-2bb85c24cb1d903751c5a6c236b40dd7.jpg";